const translationPerformanceKeys = {
  loadKey: 'translationLoadingRendered',
  errorKey: 'translationErrorRendered',
  measureName: 'translationLoadToErrorTime',
};

// Timeout (in milliseconds) to show feedback to the user that a translation is taking a long time to load.
// Usually due to this being the first time we're translating a unit.
const LONG_LOAD_NOTIFICATION_TIMEOUT = 40_000;

export { translationPerformanceKeys, LONG_LOAD_NOTIFICATION_TIMEOUT };
